import React, { useState, useImperativeHandle, useEffect, forwardRef } from 'react';
import Api from '../../../../_helpers/Api';

//images
import docIcon from '../../../../assets/img/icons/document.png';
import closeIcon from '../../../../assets/img/icons/close.png';
import loader from '../../../../assets/img/loader.svg';
import { trans } from '../../../../_providers/Translation';

function Payments(props, ref) {

    const [popup, setPopup] = useState({
        overlay: false,
        modal: false,
        data: null,
        loading: false,
        onSave: null
    });

    const [validations, setValidations] = useState(null);

    useImperativeHandle(ref, () => ({
        show: data => {
            setPopup(prev => ({
                ...prev,
                loading: false,
                data: data
            }));
            handleShow();
        },
        hide: () => {
            handleHide();
        },
        onSave: fn => {
            setPopup(prev => ({
                ...prev,
                onSave: fn
            }));
        }
    }));


    const handleShow = () => {
        setPopup(prev => ({
            ...prev,
            overlay: true
        }));

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: true,
                modal: true
            }));
        }, 50);
    }

    const handleHide = e => {
        e.preventDefault();

        setPopup(prev => ({
            ...prev,
            modal: false,
            loading: false,
        }));

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: false,
                modal: false
            }));
        }, 50);
    }

    const handleSave = e => {
        e.preventDefault();

        setPopup(prev => ({
            ...prev,
            loading: true,
        }));

        setValidations(null);

        let url = 'settings/edit';

        let data = new FormData(e.target);

        Api.post(url, data)
            .then(res => {

                handleHide(e);

                if (typeof popup.onSave === 'function') {
                    popup.onSave();
                }

                document.getElementById("form").reset();

            }).catch(error => {

                setPopup(prev => ({
                    ...prev,
                    loading: false,
                }));

                let _err = error.response;

                if (_err && _err.status && _err.status == 422) {
                    for (let [input, err] of Object.entries(_err.data.errors)) {

                        setValidations(prevState => {
                            return { ...prevState, [input]: true }
                        });
                    }
                }

            });
    }

    const handleInputChange = e => {
        let name = e.target.name.split('[')[1].replace(']', '');
        let val = e.target.value;

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: val
            }
        }));
    }

    return (
        <div className={`${popup.overlay ? 'visible' : ''} overlay`}>
            <form id="form" className={`${popup.modal ? 'show' : ''} popup-primary small`} onSubmit={handleSave}>
                <h2 className="head">
                    <img src={docIcon} alt="document" className="document-icon" />
                    {trans('headings.paymentsSettings')}
                    <img src={closeIcon} alt="close" className="close-icon" onClick={handleHide} />
                </h2>


                <div className="scrollable">
                    <div className="popup-container">
                        <div className="col">
                            <label>
                                {trans('labels.tax')} %
                            </label>

                            <input
                                type="number"
                                min="0"
                                max="100"
                                step="0.01"
                                name="data[vat]"
                                value={popup.data ? popup.data.vat : ''}
                                className={validations && validations.vat ? 'validate' : ''}
                                onChange={handleInputChange}
                            />

                        </div>
                    </div>

                    <br />

                    <div className="popup-container">
                        <div className="col">
                            <label>
                                {trans('labels.incomeTax')} %
                            </label>

                            <input
                                type="number"
                                min="0"
                                max="100"
                                step="0.01"
                                name="data[profit_tax]"
                                value={popup.data ? popup.data.profit_tax : ''}
                                className={validations && validations.profit_tax ? 'validate' : ''}
                                onChange={handleInputChange}
                            />

                        </div>
                    </div>

                    <br />

                    <div className="popup-container">
                        <div className="col">
                            <label>
                                {trans('labels.bank')}
                            </label>

                            <input
                                type="text"
                                name="data[bank_name]"
                                value={popup.data ? popup.data.bank_name : ''}
                                className={validations && validations.bank_name ? 'validate' : ''}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>

                    <br />

                    <div className="popup-container">
                        <div className="col">
                            <label>
                                IBAN
                            </label>

                            <input
                                type="text"
                                name="data[bank_iban]"
                                value={popup.data ? popup.data.bank_iban : ''}
                                className={validations && validations.bank_iban ? 'validate' : ''}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>

                    <br />

                    <div className="popup-container">
                        <div className="col">
                            <label>
                                SWIFT
                            </label>

                            <input
                                type="text"
                                name="data[bank_swift]"
                                value={popup.data ? popup.data.bank_swift : ''}
                                className={validations && validations.bank_swift ? 'validate' : ''}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>

                    <br />

                    <div className="popup-container">
                        <div className="col">
                            <label>
                                ePay Client ID
                        </label>

                            <input
                                type="text"
                                name="data[epay_client_id]"
                                value={popup.data ? popup.data.epay_client_id : ''}
                                className={validations && validations.epay_client_id ? 'validate' : ''}
                                onChange={handleInputChange}
                            />

                        </div>
                    </div>

                    <br />

                    <div className="popup-container">
                        <div className="col">
                            <label>
                                ePay Client Secret
                        </label>

                            <input
                                type="text"
                                name="data[epay_client_secret]"
                                value={popup.data ? popup.data.epay_client_secret : ''}
                                className={validations && validations.epay_client_secret ? 'validate' : ''}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>

                    <br />

                    <div className="popup-container">
                        <div className="col">
                            <label>
                                PayPal Client ID
                        </label>

                            <input
                                type="text"
                                name="data[paypal_client_id]"
                                value={popup.data ? popup.data.paypal_client_id : ''}
                                className={validations && validations.paypal_client_id ? 'validate' : ''}
                                onChange={handleInputChange}
                            />

                        </div>
                    </div>

                    <br />

                    <div className="popup-container">
                        <div className="col">
                            <label>
                                PayPal Client Secret
                        </label>

                            <input
                                type="text"
                                name="data[paypal_client_secret]"
                                value={popup.data ? popup.data.paypal_client_secret : ''}
                                className={validations && validations.paypal_client_secret ? 'validate' : ''}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>
                </div>

                <div className="footer align-center">
                    {popup.loading ?
                        <img src={loader} alt="loading" />
                        :
                        <>
                            <button className="button" onClick={handleHide}>
                                {trans('buttons.cancel')}
                            </button>
                            <button className="button button-primary" type="submit">
                                {trans('buttons.save')}
                            </button>
                        </>
                    }
                </div>
            </form>
        </div>
    )
}

export default forwardRef(Payments);